import React from "react";
var __jsx = React.createElement;
var ContentPanelBox = function ContentPanelBox(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-alice border border-solid border-neutral-60 rounded flex items-center py-2 px-3"
  }, children);
};
export default ContentPanelBox;